import script from "./AddProjectTeamMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProjectTeamMember.vue?vue&type=script&setup=true&lang=ts"

import "./AddProjectTeamMember.vue?vue&type=style&index=0&id=8381d82c&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8381d82c"]])

export default __exports__